<template>
    <v-container fluid class="fechamento-outro-dia">
        <!-- Cabeçalho -->
        <v-row>
            <v-col cols="12">
                <v-card class="mb-4" elevation="2">
                    <v-card-title class="d-flex align-center pa-4 white--text"
                        style="background: linear-gradient(135deg, #ff5722 0%, #ff7043 100%);">
                        <v-icon left color="white" size="32">mdi-calendar-clock</v-icon>
                        <div>
                            <div class="text-h5 font-weight-bold">Fechamento de Expediente - Outro Dia</div>
                            <div class="text-subtitle-2 mt-1">Feche expedientes que ficaram abertos de dias anteriores
                            </div>
                        </div>
                        <v-spacer></v-spacer>
                        <v-btn icon color="white" @click="voltarMenu">
                            <v-icon>mdi-arrow-left</v-icon>
                        </v-btn>
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>

        <!-- Filtros de Busca -->
        <v-row>
            <v-col cols="12">
                <v-card class="mb-4" elevation="1">
                    <v-card-title class="d-flex align-center">
                        <v-icon left color="primary">mdi-filter</v-icon>
                        <span>Filtros de Busca</span>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="buscarExpedientesAbertos" :loading="loadingBusca"
                            :disabled="loadingBusca">
                            <v-icon left>mdi-magnify</v-icon>
                            Buscar
                        </v-btn>
                    </v-card-title>

                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12" md="2">
                                <v-text-field v-model="filtros.data_inicio" label="Data Início" type="date"
                                    variant="outlined" density="compact" hint="Data inicial para busca"
                                    persistent-hint></v-text-field>
                            </v-col>

                            <v-col cols="12" md="2">
                                <v-text-field v-model="filtros.data_fim" label="Data Fim" type="date" variant="outlined"
                                    density="compact" hint="Data final para busca" persistent-hint></v-text-field>
                            </v-col>

                            <!-- 🆕 NOVO: Filtro por Abertura -->
                            <v-col cols="12" md="2">
                                <v-text-field v-model="filtros.id_abertura" label="ID Abertura" type="number"
                                    variant="outlined" density="compact" clearable
                                    hint="Filtrar por abertura específica" persistent-hint></v-text-field>
                            </v-col>

                            <v-col cols="12" md="2">
                                <v-select v-model="filtros.id_setor" :items="setoresDisponiveis" item-title="descricao"
                                    item-value="id" label="Setor" variant="outlined" density="compact" clearable
                                    hint="Filtrar por setor específico" persistent-hint></v-select>
                            </v-col>

                            <!-- 🆕 NOVO: Filtro por Chefe -->
                            <v-col cols="12" md="2">
                                <v-select v-model="filtros.id_chefe" :items="chefesDisponiveis" item-title="nome"
                                    item-value="id" label="Chefe" variant="outlined" density="compact" clearable
                                    hint="Filtrar por chefe específico" persistent-hint></v-select>
                            </v-col>

                            <v-col cols="12" md="2">
                                <v-text-field v-model="filtros.id_funcionario" label="ID Funcionário" type="number"
                                    variant="outlined" density="compact" clearable hint="ID específico do funcionário"
                                    persistent-hint></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row dense class="mt-2">
                            <v-col cols="12">
                                <v-btn color="grey" variant="outlined" size="small" @click="limparFiltros">
                                    <v-icon left small>mdi-filter-off</v-icon>
                                    Limpar Filtros
                                </v-btn>

                                <v-btn color="orange" variant="outlined" size="small" class="ml-2"
                                    @click="aplicarFiltroUltimos7Dias">
                                    <v-icon left small>mdi-calendar-week</v-icon>
                                    Últimos 7 Dias
                                </v-btn>

                                <v-btn color="red" variant="outlined" size="small" class="ml-2"
                                    @click="aplicarFiltroUltimos30Dias">
                                    <v-icon left small>mdi-calendar-month</v-icon>
                                    Últimos 30 Dias
                                </v-btn>

                                <v-btn color="purple" variant="outlined" size="small" class="ml-2"
                                    @click="aplicarFiltroCriticos">
                                    <v-icon left small>mdi-alert-circle</v-icon>
                                    Apenas Críticos
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- �� NOVO: Estatísticas Melhoradas -->
        <v-row v-if="estatisticas">
            <v-col cols="12" md="2">
                <v-card color="info" theme="dark">
                    <v-card-text class="text-center pa-3">
                        <v-icon size="36" class="mb-2">mdi-folder-open</v-icon>
                        <div class="text-h5 font-weight-bold">{{ estatisticas.total_aberturas }}</div>
                        <div class="text-caption">Aberturas</div>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" md="2">
                <v-card color="primary" theme="dark">
                    <v-card-text class="text-center pa-3">
                        <v-icon size="36" class="mb-2">mdi-clock-alert</v-icon>
                        <div class="text-h5 font-weight-bold">{{ estatisticas.total_expedientes }}</div>
                        <div class="text-caption">Expedientes</div>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" md="2">
                <v-card color="success" theme="dark">
                    <v-card-text class="text-center pa-3">
                        <v-icon size="36" class="mb-2">mdi-account-multiple</v-icon>
                        <div class="text-h5 font-weight-bold">{{ estatisticas.total_funcionarios }}</div>
                        <div class="text-caption">Funcionários</div>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" md="2">
                <v-card color="warning" theme="dark">
                    <v-card-text class="text-center pa-3">
                        <v-icon size="36" class="mb-2">mdi-calendar-alert</v-icon>
                        <div class="text-h5 font-weight-bold">{{ estatisticas.alertas }}</div>
                        <div class="text-caption">Alertas</div>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" md="2">
                <v-card color="error" theme="dark">
                    <v-card-text class="text-center pa-3">
                        <v-icon size="36" class="mb-2">mdi-alert-circle</v-icon>
                        <div class="text-h5 font-weight-bold">{{ estatisticas.criticos }}</div>
                        <div class="text-caption">Críticos</div>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" md="2">
                <v-card color="teal" theme="dark">
                    <v-card-text class="text-center pa-3">
                        <v-icon size="36" class="mb-2">mdi-check-circle</v-icon>
                        <div class="text-h5 font-weight-bold">{{ totalSelecionados }}</div>
                        <div class="text-caption">Selecionados</div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- �� NOVO: Lista Agrupada por Abertura -->
        <v-row>
            <v-col cols="12">
                <v-card elevation="2">
                    <v-card-title class="d-flex align-center">
                        <v-icon left color="primary">mdi-folder-multiple</v-icon>
                        <span>Aberturas de Expediente em Aberto</span>
                        <v-spacer></v-spacer>

                        <!-- Ações em Massa -->
                        <div v-if="expedientesAbertos.length > 0" class="d-flex gap-2">
                            <v-btn color="primary" size="small" variant="outlined" @click="selecionarTodosExpedientes">
                                <v-icon left small>mdi-select-all</v-icon>
                                Selecionar Todos
                            </v-btn>

                            <v-btn color="grey" size="small" variant="outlined" @click="desmarcarTodosExpedientes">
                                <v-icon left small>mdi-select-off</v-icon>
                                Desmarcar Todos
                            </v-btn>

                            <v-btn color="success" size="small" :disabled="totalSelecionados === 0"
                                @click="abrirDialogoFechamento">
                                <v-icon left small>mdi-calendar-check</v-icon>
                                Fechar Selecionados ({{ totalSelecionados }})
                            </v-btn>
                        </div>
                    </v-card-title>

                    <v-card-text>
                        <!-- Loading -->
                        <div v-if="loadingBusca" class="text-center py-8">
                            <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
                            <div class="mt-4 text-h6">Buscando expedientes em aberto...</div>
                        </div>

                        <!-- Sem dados -->
                        <div v-else-if="expedientesAbertos.length === 0" class="text-center py-8">
                            <v-icon size="64" color="grey lighten-1">mdi-calendar-check</v-icon>
                            <div class="mt-4 text-h6 grey--text">Nenhum expediente em aberto encontrado</div>
                            <div class="text-body-2 grey--text">
                                Tente ajustar os filtros ou verificar se todos os expedientes foram fechados
                                corretamente.
                            </div>
                        </div>

                        <!-- 🆕 NOVO: Cards por Abertura (sem expansion panels) -->
                        <div v-else>
                            <v-card v-for="abertura in expedientesAbertos" :key="abertura.id_abertura" class="mb-4"
                                elevation="1">
                                <!-- Header da Abertura -->
                                <v-card-title class="pa-4">
                                    <div class="d-flex align-center justify-space-between w-100">
                                        <div class="d-flex align-center">
                                            <!-- Checkbox para selecionar toda a abertura -->
                                            <v-checkbox :model-value="isAberturaCompleta(abertura)"
                                                @update:model-value="toggleAbertura(abertura)" class="mr-3"
                                                hide-details></v-checkbox>

                                            <div>
                                                <div class="text-h6 font-weight-bold">
                                                    Abertura #{{ abertura.id_abertura }} - {{ formatarDataHora(abertura.data_abertura) }}
                                                </div>
                                                <div class="text-body-2 grey--text">
                                                    <v-icon small class="mr-1">mdi-account-tie</v-icon>
                                                    {{ abertura.nome_chefe }} |
                                                    <v-icon small class="mr-1">mdi-factory</v-icon>
                                                    {{ abertura.nome_setor }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="d-flex align-center">
                                            <!-- Indicador de criticidade -->
                                            <v-chip :color="abertura.cor_indicador" size="small" theme="dark"
                                                class="mr-2">
                                                {{ abertura.nivel_criticidade }}
                                            </v-chip>

                                            <!-- Estatísticas rápidas -->
                                            <div class="text-center mr-3">
                                                <div class="text-caption grey--text">Funcionários</div>
                                                <div class="text-h6 font-weight-bold">{{
                                                    abertura.total_funcionarios_abertos }}</div>
                                            </div>

                                            <div class="text-center mr-3">
                                                <div class="text-caption grey--text">Ordens</div>
                                                <div class="text-h6 font-weight-bold">{{ abertura.total_ordens_abertas
                                                    }}</div>
                                            </div>

                                            <div class="text-center">
                                                <div class="text-caption grey--text">Tempo Máx.</div>
                                                <div class="text-body-2 font-weight-bold">{{ abertura.tempo_mais_antigo
                                                    }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </v-card-title>

                                <!-- Conteúdo da Abertura -->
                                <v-card-text>
                                    <!-- Informações da Abertura -->
                                    <v-row class="mb-3">
                                        <v-col cols="12">
                                            <v-alert :type="getAlertType(abertura.dias_mais_antigo)" density="compact"
                                                variant="outlined" class="mb-3">
                                                <div class="d-flex justify-space-between align-center">
                                                    <div>
                                                        <strong>{{ abertura.nivel_criticidade }}:</strong>
                                                        Abertura com {{ abertura.dias_mais_antigo }} dia(s) em aberto
                                                    </div>
                                                    <div class="text-caption">
                                                        Início mais antigo: {{
                                                        formatarDataHora(abertura.inicio_mais_antigo) }}
                                                    </div>
                                                </div>
                                            </v-alert>

                                            <div v-if="abertura.observacao_abertura"
                                                class="text-body-2 grey--text mb-2">
                                                <v-icon small class="mr-1">mdi-note-text</v-icon>
                                                <strong>Observação:</strong> {{ abertura.observacao_abertura }}
                                            </div>
                                        </v-col>
                                    </v-row>

                                    <!-- Tabela de Funcionários -->
                                    <!-- Tabela de Funcionários -->
                                    <!-- Tabela de Funcionários -->
                                    <v-data-table :headers="headersFuncionarios" :items="abertura.funcionarios"
                                        :items-per-page="10" item-value="id" show-select return-object
                                        v-model="funcionariosSelecionados[abertura.id_abertura]" class="elevation-1"
                                        density="compact">

                                        <!-- Slot para dias em aberto -->
                                        <template #item.dias_em_aberto="{ item }">
                                            <v-chip :color="getCorPorDias(item.dias_em_aberto)" size="small"
                                                theme="dark" class="font-weight-bold">
                                                <v-icon left small>mdi-calendar</v-icon>
                                                {{ item.dias_em_aberto }} dia(s)
                                            </v-chip>
                                        </template>

                                        <!-- Slot para tempo decorrido -->
                                        <template #item.tempo_decorrido="{ item }">
                                            <v-chip :color="getCorPorTempo(item.dias_em_aberto)" size="small"
                                                variant="outlined">
                                                <v-icon left small>mdi-clock</v-icon>
                                                {{ item.tempo_decorrido }}
                                            </v-chip>
                                        </template>

                                        <!-- Slot para data de início -->
                                        <template #item.inicio_at="{ item }">
                                            <div class="text-body-2">
                                                <div>{{ formatarData(item.inicio_at) }}</div>
                                                <div class="text-caption grey--text">{{ formatarHora(item.inicio_at) }}
                                                </div>
                                            </div>
                                        </template>

                                        <!-- Slot para ações individuais -->
                                        <template #item.actions="{ item }">
                                            <v-btn color="success" size="small" variant="outlined"
                                                @click="abrirDialogoFechamentoIndividual(item, abertura)">
                                                <v-icon small>mdi-calendar-check</v-icon>
                                            </v-btn>
                                        </template>
                                    </v-data-table>
                                </v-card-text>
                            </v-card>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Diálogo de Fechamento -->
        <v-dialog v-model="mostrarDialogoFechamento" max-width="800" persistent>
            <v-card>
                <v-card-title class="d-flex align-center pa-4 white--text"
                    style="background: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%);">
                    <v-icon left color="white" size="28">mdi-calendar-check</v-icon>
                    <span class="text-h6 font-weight-bold">Fechar Expedientes</span>
                </v-card-title>

                <v-card-text class="pa-6">
                    <v-alert type="warning" variant="outlined" density="compact" class="mb-4">
                        <strong>Atenção:</strong> Esta ação irá fechar definitivamente os expedientes selecionados com a
                        data/hora informada.
                    </v-alert>

                    <!-- Configurações de Fechamento -->
                    <v-row dense>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="dadosFechamento.data_encerramento"
                                label="Data e Hora de Encerramento" type="datetime-local" variant="outlined"
                                density="compact" required :rules="[v => !!v || 'Data e hora são obrigatórias']"
                                hint="Informe quando realmente o expediente foi encerrado"
                                persistent-hint></v-text-field>
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-select v-model="dadosFechamento.id_status_final" :items="statusFechamento"
                                item-title="text" item-value="value" label="Status de Fechamento" variant="outlined"
                                density="compact" required :rules="[v => !!v || 'Status é obrigatório']"></v-select>
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12">
                            <v-textarea v-model="dadosFechamento.motivo_fechamento" label="Motivo do Fechamento Manual"
                                variant="outlined" density="compact" rows="3"
                                placeholder="Ex: Funcionário esqueceu de fechar o expediente no dia anterior"
                                maxlength="200" counter></v-textarea>
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12">
                            <v-textarea v-model="dadosFechamento.observacao" label="Observações Adicionais"
                                variant="outlined" density="compact" rows="2"
                                placeholder="Observações gerais sobre o fechamento" maxlength="150"
                                counter></v-textarea>
                        </v-col>
                    </v-row>

                    <!-- Lista de Expedientes Selecionados -->
                    <v-divider class="my-4"></v-divider>

                    <div class="d-flex justify-space-between align-center mb-3">
                        <h4>Expedientes que serão fechados ({{ totalSelecionados }})</h4>
                    </div>

                    <div class="expedientes-resumo" style="max-height: 300px; overflow-y: auto;">
                        <div v-for="abertura in expedientesAbertos" :key="abertura.id_abertura">
                            <div
                                v-if="funcionariosSelecionados[abertura.id_abertura] && funcionariosSelecionados[abertura.id_abertura].length > 0">
                                <!-- Cabeçalho da abertura -->
                                <div class="px-0 py-2 font-weight-bold text-subtitle-2">
                                    <v-icon small class="mr-2">mdi-folder</v-icon>
                                    Abertura #{{ abertura.id_abertura }} - {{ abertura.nome_chefe }}
                                </div>

                                <v-list density="compact">
                                    <v-list-item v-for="funcionario in funcionariosSelecionados[abertura.id_abertura]"
                                        :key="funcionario.id" class="px-0">
                                        <template v-slot:prepend>
                                            <v-chip :color="getCorPorDias(funcionario.dias_em_aberto)" size="small"
                                                theme="dark">
                                                {{ funcionario.tempo_decorrido }}
                                            </v-chip>
                                        </template>

                                        <v-list-item-title class="text-body-2">
                                            <strong>{{ funcionario.nome_funcionario }}</strong> - Ordem {{
                                            funcionario.numero_ordem }}
                                        </v-list-item-title>
                                        <v-list-item-subtitle class="text-caption">
                                            {{ funcionario.cliente }} |
                                            Aberto há {{ funcionario.dias_em_aberto }} dia(s)
                                        </v-list-item-subtitle>
                                    </v-list-item>
                                </v-list>
                            </div>
                        </div>
                    </div>
                </v-card-text>

                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>

                    <v-btn color="grey" variant="outlined" @click="fecharDialogoFechamento"
                        :disabled="loadingFechamento">
                        <v-icon left>mdi-close</v-icon>
                        Cancelar
                    </v-btn>

                    <v-btn color="success" @click="executarFechamento" :loading="loadingFechamento"
                        :disabled="!dadosFechamento.data_encerramento || !dadosFechamento.id_status_final || totalSelecionados === 0">
                        <v-icon left>mdi-check</v-icon>
                        Fechar Expedientes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Diálogo de Loading -->
        <v-dialog v-model="loadingFechamento" persistent max-width="400">
            <v-card>
                <v-card-text class="text-center pa-6">
                    <v-progress-circular indeterminate color="success" size="64"></v-progress-circular>
                    <div class="mt-4 text-h6">{{ mensagemLoading }}</div>
                    <div class="text-body-2 grey--text mt-2">
                        Processando {{ totalSelecionados }} expediente(s)...
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { ref, reactive, computed, onMounted } from 'vue'
import { aberturaExpedienteService } from "@/services/aberturaExpedienteService";
import { maquinaMapaService } from "@/services/maquinaMapaService";
import { useToast } from "vue-toastification";
import { useRouter } from 'vue-router'

export default {
    name: "FechamentoExpedienteOutroDia",

    setup() {
        const router = useRouter()
        const toast = useToast()

        // Estados reativos
        const loadingBusca = ref(false)
        const loadingFechamento = ref(false)
        const mensagemLoading = ref("Processando fechamento...")

        // Filtros de busca
        const filtros = reactive({
            data_inicio: null,
            data_fim: null,
            id_setor: null,
            id_funcionario: null,
            id_abertura: null,
            id_chefe: null,
        })

        // Dados
        const expedientesAbertos = ref([])
        const funcionariosSelecionados = reactive({}) // 🔧 CORRIGIDO: usar reactive
        const setoresDisponiveis = ref([])
        const chefesDisponiveis = ref([])
        const estatisticas = ref(null)

        // Diálogo de fechamento
        const mostrarDialogoFechamento = ref(false)
        const dadosFechamento = reactive({
            data_encerramento: null,
            id_status_final: 22,
            motivo_fechamento: '',
            observacao: '',
        })

        // Configurações
        const statusFechamento = [
            { text: "Fim do Expediente", value: 22 },
            { text: "Saída com Justificativa", value: 20 },
            { text: "Saída sem Justificativa", value: 21 },
        ]

        const headersFuncionarios = [
            { title: "ID", key: "id_funcionario", sortable: true, width: "80px" },
            { title: "Funcionário", key: "nome_funcionario", sortable: true },
            { title: "Ordem", key: "numero_ordem", sortable: true, width: "100px" },
            { title: "Cliente", key: "cliente", sortable: true },
            { title: "Status", key: "status_inicio", sortable: true },
            { title: "Início", key: "inicio_at", sortable: true },
            { title: "Dias em Aberto", key: "dias_em_aberto", sortable: true, width: "130px" },
            { title: "Tempo Decorrido", key: "tempo_decorrido", sortable: false, width: "140px" },
            { title: "Ações", key: "actions", sortable: false, width: "100px" },
        ]

        // Computed
        const totalSelecionados = computed(() => {
            return Object.values(funcionariosSelecionados)
                .reduce((total, funcionarios) => total + (funcionarios?.length || 0), 0)
        })

        // Methods
        const carregarSetores = async () => {
            try {
                const response = await maquinaMapaService.fetchSetores()
                if (response && Array.isArray(response)) {
                    setoresDisponiveis.value = response
                }
            } catch (error) {
                console.error("Erro ao carregar setores:", error)
                mostrarToast("Erro ao carregar setores", "error")
            }
        }

        const carregarChefes = async () => {
            try {
                chefesDisponiveis.value = [
                    { id: 1, nome: "Maria Santos" },
                    { id: 2, nome: "Carlos Lima" },
                    { id: 3, nome: "Roberto Silva" },
                ]
            } catch (error) {
                console.error("Erro ao carregar chefes:", error)
            }
        }

        const configurarFiltrosIniciais = () => {
            const hoje = new Date()
            const seteDiasAtras = new Date()
            seteDiasAtras.setDate(hoje.getDate() - 7)

            filtros.data_inicio = formatarDataParaInput(seteDiasAtras)
            filtros.data_fim = formatarDataParaInput(hoje)

            const ontem = new Date()
            ontem.setDate(ontem.getDate() - 1)
            ontem.setHours(18, 0, 0, 0)

            dadosFechamento.data_encerramento = null;
        }

        const buscarExpedientesAbertos = async () => {
            loadingBusca.value = true

            try {
                const response = await aberturaExpedienteService.buscarExpedientesAbertos(filtros)

                if (response.success) {
                    expedientesAbertos.value = response.dados || []
                    estatisticas.value = response.estatisticas || null

                    // 🔍 DEBUG: Verificar estrutura dos dados
                    console.log("🔍 Dados recebidos do backend:", response.dados)

                    if (response.dados && response.dados.length > 0) {
                        console.log("🔍 Primeira abertura:", response.dados[0])
                        console.log("🔍 Funcionários da primeira abertura:", response.dados[0].funcionarios)

                        if (response.dados[0].funcionarios && response.dados[0].funcionarios.length > 0) {
                            console.log("🔍 Primeiro funcionário:", response.dados[0].funcionarios[0])
                        }
                    }

                    // Limpar e inicializar seleções
                    Object.keys(funcionariosSelecionados).forEach(key => {
                        delete funcionariosSelecionados[key]
                    })

                    expedientesAbertos.value.forEach(abertura => {
                        funcionariosSelecionados[abertura.id_abertura] = []
                    })

                    mostrarToast(
                        `${response.estatisticas?.total_expedientes || 0} expediente(s) em aberto encontrado(s)`,
                        response.estatisticas?.total_expedientes > 0 ? "success" : "info"
                    )
                } else {
                    expedientesAbertos.value = []
                    estatisticas.value = null
                    mostrarToast(response.message || "Nenhum expediente encontrado", "warning")
                }
            } catch (error) {
                console.error("Erro ao buscar expedientes:", error)
                mostrarToast("Erro ao buscar expedientes em aberto", "error")
                expedientesAbertos.value = []
                estatisticas.value = null
            } finally {
                loadingBusca.value = false
            }
        }

        const limparFiltros = () => {
            Object.assign(filtros, {
                data_inicio: null,
                data_fim: null,
                id_setor: null,
                id_funcionario: null,
                id_abertura: null,
                id_chefe: null,
            })
        }

        const aplicarFiltroUltimos7Dias = () => {
            const hoje = new Date()
            const seteDiasAtras = new Date()
            seteDiasAtras.setDate(hoje.getDate() - 7)

            filtros.data_inicio = formatarDataParaInput(seteDiasAtras)
            filtros.data_fim = formatarDataParaInput(hoje)
        }

        const aplicarFiltroUltimos30Dias = () => {
            const hoje = new Date()
            const trintaDiasAtras = new Date()
            trintaDiasAtras.setDate(hoje.getDate() - 30)

            filtros.data_inicio = formatarDataParaInput(trintaDiasAtras)
            filtros.data_fim = formatarDataParaInput(hoje)
        }

        const aplicarFiltroCriticos = () => {
            buscarExpedientesAbertos()
        }

        const isAberturaCompleta = (abertura) => {
            const selecionados = funcionariosSelecionados[abertura.id_abertura] || []
            return selecionados.length === abertura.funcionarios.length && abertura.funcionarios.length > 0
        }

        const toggleAbertura = (abertura) => {
            if (isAberturaCompleta(abertura)) {
                funcionariosSelecionados[abertura.id_abertura] = []
            } else {
                // 🔧 GARANTIR QUE ESTAMOS COPIANDO OS OBJETOS COMPLETOS
                funcionariosSelecionados[abertura.id_abertura] = [...abertura.funcionarios]
            }
        }


        const selecionarTodosExpedientes = () => {
            expedientesAbertos.value.forEach(abertura => {
                // 🔧 GARANTIR QUE ESTAMOS COPIANDO OS OBJETOS COMPLETOS
                funcionariosSelecionados[abertura.id_abertura] = [...abertura.funcionarios]
            })
        }

        const desmarcarTodosExpedientes = () => {
            expedientesAbertos.value.forEach(abertura => {
                funcionariosSelecionados[abertura.id_abertura] = []
            })
        }

        const abrirDialogoFechamento = () => {
            if (totalSelecionados.value === 0) {
                mostrarToast("Selecione pelo menos um expediente para fechar", "warning")
                return
            }

            mostrarDialogoFechamento.value = true
        }
        const abrirDialogoFechamentoIndividual = (funcionario, abertura) => {
            desmarcarTodosExpedientes()
            // 🔧 GARANTIR QUE ESTAMOS PASSANDO O OBJETO COMPLETO
            funcionariosSelecionados[abertura.id_abertura] = [funcionario]
            mostrarDialogoFechamento.value = true
        }


        const fecharDialogoFechamento = () => {
            mostrarDialogoFechamento.value = false
            dadosFechamento.motivo_fechamento = ''
            dadosFechamento.observacao = ''
        }


        const executarFechamento = async () => {
  if (!validarDadosFechamento()) return
  
  loadingFechamento.value = true
  mensagemLoading.value = "Processando fechamento dos expedientes..."
  
  try {
    const funcionarios = []
    
    console.log("🔍 Debug - funcionariosSelecionados:", funcionariosSelecionados)
    
    Object.entries(funcionariosSelecionados).forEach(([idAbertura, funcionariosList]) => {
      if (funcionariosList && funcionariosList.length > 0) {
        const abertura = expedientesAbertos.value.find(a => a.id_abertura == idAbertura)
        
        if (!abertura) {
          console.error(`❌ Abertura ${idAbertura} não encontrada`)
          return
        }
        
        funcionariosList.forEach(funcionarioId => {
          let funcionario
          if (typeof funcionarioId === 'object') {
            funcionario = funcionarioId
          } else {
            funcionario = abertura.funcionarios.find(f => f.id == funcionarioId)
          }
          
          if (!funcionario) {
            console.error(`❌ Funcionário com ID ${funcionarioId} não encontrado na abertura ${idAbertura}`)
            return
          }
          
          if (!funcionario.id_funcionario || !funcionario.id_ordem || !funcionario.id_ordem_status) {
            console.error("❌ Campos obrigatórios não encontrados:", funcionario)
            return
          }
          
          funcionarios.push({
            id_abertura: parseInt(idAbertura),
            id_funcionario: parseInt(funcionario.id_funcionario),
            id_ordem: parseInt(funcionario.id_ordem),
            id_ordem_status: parseInt(funcionario.id_ordem_status),
            id_status_final: parseInt(dadosFechamento.id_status_final),
          })
        })
      }
    })
    
    console.log("✅ Funcionários coletados corretamente:", funcionarios)
    
    if (funcionarios.length === 0) {
      mostrarToast("Nenhum funcionário válido selecionado para fechamento", "warning")
      return
    }
    
    // 🔧 CORREÇÃO: Não converter timezone - usar valor direto do input
    const dataFormatada = dadosFechamento.data_encerramento.replace('T', ' ') + ':00'
    
    console.log("🔍 Debug - Data original do input:", dadosFechamento.data_encerramento)
    console.log("🔍 Debug - Data formatada para backend:", dataFormatada)
    
    const dadosEnvio = {
      funcionarios,
      data_encerramento: dataFormatada,
      motivo_fechamento: dadosFechamento.motivo_fechamento || 'Fechamento manual de expediente',
      observacao: dadosFechamento.observacao || '',
    }
    
    console.log("📤 Dados finais para envio:", dadosEnvio)
    
    const response = await aberturaExpedienteService.fechamentoOutroDia(dadosEnvio)
    
    if (response.success) {
      mostrarToast(
        `${response.total_alteracoes} expediente(s) fechado(s) com sucesso!`, 
        "success"
      )
      
      fecharDialogoFechamento()
      await buscarExpedientesAbertos()
      
    } else {
      mostrarToast(response.message || "Erro no fechamento", "error")
    }
    
  } catch (error) {
    console.error("❌ Erro no fechamento:", error)
    console.error("❌ Detalhes do erro:", error.response?.data)
    mostrarToast("Erro ao fechar expedientes. Tente novamente.", "error")
  } finally {
    loadingFechamento.value = false
  }
}

        const validarDadosFechamento = () => {
            if (!dadosFechamento.data_encerramento) {
                mostrarToast("Data e hora de encerramento são obrigatórias", "warning")
                return false
            }

            if (!dadosFechamento.id_status_final) {
                mostrarToast("Status de fechamento é obrigatório", "warning")
                return false
            }

            const dataEncerramento = new Date(dadosFechamento.data_encerramento)
            const agora = new Date()

            if (dataEncerramento > agora) {
                mostrarToast("Data de encerramento não pode ser futura", "warning")
                return false
            }

            return true
        }

        // Utilitários
        const getCorPorDias = (dias) => {
            if (dias <= 1) return "green"
            if (dias <= 2) return "orange"
            if (dias <= 5) return "red"
            return "purple"
        }

        const getCorPorTempo = (dias) => {
            if (dias <= 1) return "success"
            if (dias <= 2) return "warning"
            return "error"
        }

        const getAlertType = (dias) => {
            if (dias > 5) return "error"
            if (dias > 2) return "warning"
            if (dias > 1) return "info"
            return "success"
        }

        const formatarData = (dataString) => {
            if (!dataString) return "N/A"
            const data = new Date(dataString)
            return data.toLocaleDateString("pt-BR")
        }

        const formatarHora = (dataString) => {
            if (!dataString) return "N/A"
            const data = new Date(dataString)
            return data.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })
        }

        const formatarDataHora = (dataString) => {
            if (!dataString) return "N/A"
            const data = new Date(dataString)
            return data.toLocaleString("pt-BR")
        }

        const formatarDataParaInput = (data) => {
            if (!data) return null
            const dataObj = typeof data === 'string' ? new Date(data) : data
            return dataObj.toISOString().split('T')[0]
        }

        const mostrarToast = (mensagem, tipo = "info") => {
            toast[tipo](mensagem)
        }

        const voltarMenu = () => {
            router.push({ name: "MenuDefault" })
        }

        const inicializar = async () => {
            await carregarSetores()
            await carregarChefes()
            configurarFiltrosIniciais()
            await buscarExpedientesAbertos()
        }

        // Lifecycle
        onMounted(() => {
            inicializar()
        })

        return {
            // Estados
            loadingBusca,
            loadingFechamento,
            mensagemLoading,
            filtros,
            expedientesAbertos,
            funcionariosSelecionados,
            setoresDisponiveis,
            chefesDisponiveis,
            estatisticas,
            mostrarDialogoFechamento,
            dadosFechamento,
            statusFechamento,
            headersFuncionarios,

            // Computed
            totalSelecionados,

            // Methods
            buscarExpedientesAbertos,
            limparFiltros,
            aplicarFiltroUltimos7Dias,
            aplicarFiltroUltimos30Dias,
            aplicarFiltroCriticos,
            isAberturaCompleta,
            toggleAbertura,
            selecionarTodosExpedientes,
            desmarcarTodosExpedientes,
            abrirDialogoFechamento,
            abrirDialogoFechamentoIndividual,
            fecharDialogoFechamento,
            executarFechamento,
            getCorPorDias,
            getCorPorTempo,
            getAlertType,
            formatarData,
            formatarHora,
            formatarDataHora,
            voltarMenu,
        }
    }
}
</script>

<style scoped>
.fechamento-outro-dia {
    min-height: 100vh;
    background-color: #f5f5f5;
}

.expedientes-resumo {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    background-color: #fafafa;
}

.gap-2 {
    gap: 8px;
}

/* Responsividade */
@media (max-width: 768px) {
    .fechamento-outro-dia {
        padding: 8px;
    }

    .v-card-title {
        flex-direction: column;
        align-items: flex-start !important;
    }

    .v-card-title .v-spacer {
        display: none;
    }
}
</style>